/** Espelha origem_ocorrencia (db_vendas) e OrigemOcorrenciaEnum (API Vendas e OrquestradorVendas): quem produziu a ocorrência. */
export enum OrigemOcorrenciaEnum {
    Usuario = 1,
    Sistema = 2,
    Automacao = 3,
    RotinaAgendada = 4,
    ServicoExterno = 5,
}
